import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { META_LAST_EXPORT } from '@/db/repositories/meta';
import { differenceInDays, today, toLocalDate } from '@/lib/datetime';

export interface BackupState {
  lastExportAt: string | null;
  /** `null`, wenn noch nie exportiert wurde. */
  daysSinceExport: number | null;
  /** Ab 7 Tagen erinnern, ab 21 Tagen nicht mehr wegklickbar. */
  shouldNag: boolean;
  isUrgent: boolean;
}

export const NAG_AFTER_DAYS = 7;
export const NAG_URGENT_AFTER_DAYS = 21;

export function useBackupState(): BackupState {
  const lastExportAt = useLiveQuery(
    async () => ((await db.meta.get(META_LAST_EXPORT))?.value as string | undefined) ?? null,
    [],
    null,
  );

  if (!lastExportAt) {
    return { lastExportAt: null, daysSinceExport: null, shouldNag: true, isUrgent: false };
  }

  const days = differenceInDays(toLocalDate(new Date(lastExportAt)), today());

  return {
    lastExportAt,
    daysSinceExport: days,
    // Ein Datum in der Zukunft (Uhr ging einmal vor) gilt als unbekannt alt: erinnern.
    shouldNag: days < 0 || days >= NAG_AFTER_DAYS,
    isUrgent: days >= NAG_URGENT_AFTER_DAYS,
  };
}
